// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"19a5506f19df079e3812","1642":"a118a4db4cfaa015f956","2983":"5f97270a340ed499fb20","9279":"53e6df4e322a9ebc3b10"}[chunkId] + "";
};